import React, {useContext} from 'react'

import {atomButtonDesigns} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeNotification, {AUTO_CLOSE, BRDS_SIZE, TYPES, VARIATIONS} from '@s-ui/react-molecule-notification'
import LoginBanner from '@adv-mt/mt-login-banner'
import NewsletterForm from '@adv-mt/mt-newsletter-form'

// eslint-disable-next-line react/prop-types
const Notify = ({sendVerificationEmail, title, type}) => {
  const RESEND_EMAIL_BUTTON = {
    children: 'Reenviar correo',
    design: atomButtonDesigns.OUTLINE,
    onClick: () => sendVerificationEmail()
  }

  return (
    <>
      <MoleculeNotification
        type={type || TYPES.success}
        roundedCorners={BRDS_SIZE.medium}
        autoClose={AUTO_CLOSE.manual}
        show
        showCloseButton={false}
        variation={type === TYPES.warning ? VARIATIONS.positive : VARIATIONS.negative}
        {...(sendVerificationEmail ? {buttons: [RESEND_EMAIL_BUTTON]} : {})}
      >
        {title}
      </MoleculeNotification>
    </>
  )
}

const NewsletterLoginBanner = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {LOGIN_SOURCE_ID_SUBSCRIBE_NEWSLETTER} = config.get('login')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const {HIT_ORIGINS} = config.get('tracking')

  return (
    <LoginBanner
      imageSrc={`${URL_STATICS_IMAGES}illustrations/newsletter.svg`}
      title={i18n.t('LOGIN_BANNER.NEWSLETTER_SUBSCRIPTION.TITLE')}
      description={i18n.t('LOGIN_BANNER.NEWSLETTER_SUBSCRIPTION.DESCRIPTION')}
      loginLess
      modalLoginSource={LOGIN_SOURCE_ID_SUBSCRIBE_NEWSLETTER}
      trackingOrigin={HIT_ORIGINS.NEWSLETTER_SUBSCRIPTION}
    />
  )
}

export const resolveSubscriptionUIState = ({
  consents,
  domain,
  isSubscribedState,
  onAfterSubscribe,
  pageName,
  emailSent,
  sendVerificationEmail,
  user
}) => {
  const config = domain.get('config')
  const {USER_CONSENTS} = config.get('user')
  const isLogged = Boolean(user)

  const consentEnabled = () => Boolean(consents?.getConsentStatus({key: USER_CONSENTS.PORTAL_ANNOUNCEMENTS}))

  const states = {
    'no-user': {
      check: () => !isLogged,
      render: () => <NewsletterLoginBanner />
    },
    'no-consents': {
      check: () => !consents,
      render: () => null
    },
    'email-sent': {
      check: () => emailSent,
      render: () => <Notify title="Correo de verificación enviado" />
    },
    'not-verified-subscribed-after-click': {
      check: () => !user.isEmailConfirmed && consentEnabled() && isSubscribedState,
      render: () => {
        return (
          <Notify
            title="Para finalizar la suscripción y recibir noticias debes verificar tu cuenta"
            type={TYPES.warning}
            sendVerificationEmail={sendVerificationEmail}
          />
        )
      }
    },
    'verified-subscribed-after-click': {
      check: () => user.isEmailConfirmed && consentEnabled() && isSubscribedState,
      render: () => {
        return <Notify title="Suscripción completada" />
      }
    },
    'not-verified-subscribed': {
      check: () => !user.isEmailConfirmed && consentEnabled() && !isSubscribedState,
      render: () => {
        return (
          <Notify
            title="Estás suscrito a nuestra newsletter pero debes verificar tu cuenta para recibir noticias."
            type={TYPES.warning}
            sendVerificationEmail={sendVerificationEmail}
          />
        )
      }
    },
    'verified-subscribed': {
      check: () => user.isEmailConfirmed && consentEnabled() && !isSubscribedState,
      render: () => null
    },
    'not-verified-not-subscribed': {
      check: () => !user.isEmailConfirmed && !consentEnabled() && !isSubscribedState,
      render: () => (
        <NewsletterForm
          pageName={pageName}
          consents={consents}
          user={user}
          onAfterSubscribe={onAfterSubscribe}
          isLarge
          hasCheckbox={false}
        />
      )
    },
    'verified-not-subscribed': {
      check: () => user.isEmailConfirmed && !consentEnabled() && !isSubscribedState,
      render: () => (
        <NewsletterForm
          pageName={pageName}
          consents={consents}
          user={user}
          onAfterSubscribe={onAfterSubscribe}
          isLarge
          hasCheckbox={false}
        />
      )
    }
  }

  const stateToDisplay = Object.keys(states).find(state => states[state].check())

  return {uiID: stateToDisplay, ...states[stateToDisplay]} || null
}
